module.exports = __webpack_public_path__ + "static/media/conference_20.f500eecd.jpg";